import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Bus, BookOpen, Users, Laptop, FlaskConical, Microscope, Calculator, Atom, Cpu, Play } from 'lucide-react';

interface Facility {
  id: string;
  title: string;
  description: string;
  icon: React.ReactNode;
  images: string[];
  color: string;
}

const facilities: Facility[] = [
  {
    id: 'transport',
    title: 'School Transport',
    description: 'The School has its own Bus Service, for the students residing in the far away localities. We have Nineteen buses for New Mandi, Teenpani, Old I.T.I., Garaparao, Motinagar, Motahaldu, Beriparao, Halduchaur, Lalkuan & Bindukhatta respectively. We are also providing school bus facility in Gaulapaar, Kunwarpur, Shantipuri, Pantnagar from the session 2024-25.',
    icon: <Bus className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/3b82f6/white?text=Bus+Fleet', 'https://via.placeholder.com/600x400/1d4ed8/white?text=School+Bus', 'https://via.placeholder.com/600x400/2563eb/white?text=Transport+Service'],
    color: 'bg-gradient-to-br from-blue-500 to-blue-700'
  },
  {
    id: 'library',
    title: 'Library',
    description: 'The School library is the hub of intellectual activities and is rich in reading material and reference resources, which provide information and ideas that are fundamental for functioning successfully in today\'s information and knowledge-based society. The students can update their knowledge about the latest developments in various fields through the different newspapers and magazines.',
    icon: <BookOpen className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/059669/white?text=Library+Hall', 'https://via.placeholder.com/600x400/047857/white?text=Reading+Section', 'https://via.placeholder.com/600x400/065f46/white?text=Book+Collection', 'https://via.placeholder.com/600x400/064e3b/white?text=Study+Area', 'https://via.placeholder.com/600x400/0f766e/white?text=Reference+Books'],
    color: 'bg-gradient-to-br from-emerald-500 to-emerald-700'
  },
  {
    id: 'classrooms',
    title: 'Class Rooms',
    description: 'Neat clean and spacious and well furnished Classrooms providing unique atmosphere for students to concentrate in their studies. Our Classrooms are properly ventilated, well-lit and spacious. Specially designed, modern, ergonomic and attractive furniture is provided. Projectors/LED Panels are installed in each section. Presently 44 Classrooms are installed with LED Panels/Projectors. All classes are fitted with CCTV Camera.',
    icon: <Users className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/dc2626/white?text=Modern+Classroom', 'https://via.placeholder.com/600x400/b91c1c/white?text=LED+Panel+Room', 'https://via.placeholder.com/600x400/991b1b/white?text=Study+Environment', 'https://via.placeholder.com/600x400/7f1d1d/white?text=Smart+Furniture', 'https://via.placeholder.com/600x400/dc2626/white?text=Digital+Learning'],
    color: 'bg-gradient-to-br from-red-500 to-red-700'
  },
  {
    id: 'chemistry',
    title: 'Chemistry Laboratory',
    description: 'The Chemistry lab of the School is fully equipped with necessary apparatus, chemicals, salts and solutions required by the students to learn through experiments. Realising the power of concentrated acids and watching flame of different colours during flame test make the student aware and bring the joy of learning. Our chemistry lab helps students understand different chemical reactions in daily life.',
    icon: <FlaskConical className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/7c3aed/white?text=Chemistry+Lab', 'https://via.placeholder.com/600x400/6d28d9/white?text=Lab+Equipment', 'https://via.placeholder.com/600x400/5b21b6/white?text=Chemical+Setup', 'https://via.placeholder.com/600x400/4c1d95/white?text=Experiment+Area', 'https://via.placeholder.com/600x400/581c87/white?text=Safety+Equipment'],
    color: 'bg-gradient-to-br from-purple-500 to-purple-700'
  },
  {
    id: 'ncc',
    title: 'NCC',
    description: 'School is having 2 different wings of NCC for students of class VIII onwards. We are offering 150 seats for JD/JW and SD/SW under: 1 UK AIR SQN NCC, PANTNAGAR and 79 BN NCC, NAINITAL.',
    icon: <Users className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/f59e0b/white?text=NCC+Training', 'https://via.placeholder.com/600x400/d97706/white?text=Parade+Ground', 'https://via.placeholder.com/600x400/b45309/white?text=Air+Squadron'],
    color: 'bg-gradient-to-br from-amber-500 to-amber-700'
  },
  {
    id: 'physics',
    title: 'Physics Laboratory',
    description: 'The School has a well equipped Physics lab where students learn various concepts of the subject by practically experimenting with the apparatus. Experiments not only help students in understanding the concept in a better way but also create an excitement among students. Our Physics laboratory is equipped with all the necessary equipment and models to demonstrate practical applications of theoretical physics.',
    icon: <Atom className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/0ea5e9/white?text=Physics+Lab', 'https://via.placeholder.com/600x400/0284c7/white?text=Experiment+Setup', 'https://via.placeholder.com/600x400/0369a1/white?text=Lab+Equipment', 'https://via.placeholder.com/600x400/075985/white?text=Physics+Models', 'https://via.placeholder.com/600x400/0c4a6e/white?text=Practical+Work'],
    color: 'bg-gradient-to-br from-sky-500 to-sky-700'
  },
  {
    id: 'biology',
    title: 'Biology Laboratory',
    description: 'The Biology lab is well stocked with Microscopes, live specimens of plants and animals, human skeleton, clay models and charts. Understanding life and working of different body parts is one of the most challenging things. With our well stocked and equipped Biology lab we make things simpler for our students.',
    icon: <Microscope className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/16a34a/white?text=Biology+Lab', 'https://via.placeholder.com/600x400/15803d/white?text=Microscope+Station', 'https://via.placeholder.com/600x400/166534/white?text=Specimens+Collection', 'https://via.placeholder.com/600x400/14532d/white?text=Human+Skeleton', 'https://via.placeholder.com/600x400/15803d/white?text=Biology+Models'],
    color: 'bg-gradient-to-br from-green-500 to-green-700'
  },
  {
    id: 'computer',
    title: 'Computer Lab',
    description: 'Computer education is an integral part of modern education system. Our School also emphasize on computer education in accordance with C.B.S.E curriculum. We have separate labs for Juniors and Seniors. We have 42 Computers installed in Senior Computer lab and 21 Computers installed in Junior Lab. All computers have Windows based systems with office suites and programming languages.',
    icon: <Laptop className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/ec4899/white?text=Computer+Lab', 'https://via.placeholder.com/600x400/db2777/white?text=Senior+Lab', 'https://via.placeholder.com/600x400/be185d/white?text=Junior+Lab', 'https://via.placeholder.com/600x400/9d174d/white?text=Programming+Setup', 'https://via.placeholder.com/600x400/831843/white?text=IT+Education'],
    color: 'bg-gradient-to-br from-pink-500 to-pink-700'
  },
  {
    id: 'mathematics',
    title: 'Mathematics Lab',
    description: 'Math Lab provides opportunity for children to enjoy Mathematics, understand its basic structure, pose and solve meaningful problems. It enables the student to learn Mathematics with the help of concrete objects and to exhibit its relatedness with everyday life.',
    icon: <Calculator className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/8b5cf6/white?text=Math+Lab', 'https://via.placeholder.com/600x400/7c3aed/white?text=Math+Models', 'https://via.placeholder.com/600x400/6d28d9/white?text=Problem+Solving', 'https://via.placeholder.com/600x400/5b21b6/white?text=Concrete+Learning', 'https://via.placeholder.com/600x400/4c1d95/white?text=Math+Tools'],
    color: 'bg-gradient-to-br from-violet-500 to-violet-700'
  },
  {
    id: 'composite',
    title: 'Composite Science Lab',
    description: 'The School has an extensive Composite Science lab which provides an experimental foundation for the concepts introduced. Students enhance their learning by doing varied experiments which kindles their interest visually and kinaesthetically. It enables the learners to familiarize themselves with experimental apparatus, scientific methods applied, and to make careful observations.',
    icon: <FlaskConical className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/f97316/white?text=Composite+Lab', 'https://via.placeholder.com/600x400/ea580c/white?text=Multi+Science', 'https://via.placeholder.com/600x400/dc2626/white?text=Experiment+Station', 'https://via.placeholder.com/600x400/b91c1c/white?text=Science+Equipment'],
    color: 'bg-gradient-to-br from-orange-500 to-orange-700'
  },
  {
    id: 'stem',
    title: 'STEM & Robotics Lab',
    description: 'In STEM Lab (Science, Technology, Engineering and Mathematics), students get the experience of performing hands on activities and build their conceptual understanding. STEM Lab provides the platform to develop the scientific attitude among the students. Robotics programme stimulates tender minds to engage with latest technology and nurture scientific outlook to be future Techno scientists.',
    icon: <Cpu className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/06b6d4/white?text=STEM+Lab', 'https://via.placeholder.com/600x400/0891b2/white?text=Robotics+Station'],
    color: 'bg-gradient-to-br from-cyan-500 to-cyan-700'
  },
  {
    id: 'interactive',
    title: 'Interactive Classes',
    description: 'In today\'s competitive world, children need skill sets beyond subject knowledge. Smart classes comprise interactive modules like videos and presentations. Our Smart classes use animated visuals to teach concepts. Visual learning is eye-catching and students easily relate with them. Highly engaging visuals and animations make learning enjoyable while improving academic performance.',
    icon: <Play className="w-8 h-8" />,
    images: ['https://via.placeholder.com/600x400/84cc16/white?text=Smart+Classroom', 'https://via.placeholder.com/600x400/65a30d/white?text=Interactive+Board', 'https://via.placeholder.com/600x400/4d7c0f/white?text=Digital+Learning', 'https://via.placeholder.com/600x400/365314/white?text=Visual+Teaching'],
    color: 'bg-gradient-to-br from-lime-500 to-lime-700'
  }
];

const ImageCarousel: React.FC<{ images: string[]; title: string }> = ({ images, title }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="relative group">
      <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden">
        <img 
          src={images[currentIndex]} 
          alt={`${title} - Image ${currentIndex + 1}`}
          className="w-full h-full object-cover transition-all duration-500"
        />
      </div>
      
      {images.length > 1 && (
        <>
          <button
            onClick={prevImage}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          
          <button
            onClick={nextImage}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
          
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  index === currentIndex ? 'bg-white' : 'bg-white/50'
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const FacilityCard: React.FC<{ facility: Facility; index: number }> = ({ facility, index }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div 
      className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden transform hover:-translate-y-2"
      style={{ animationDelay: `${index * 100}ms` }}
    >
      <div className={`${facility.color} p-6 text-white relative overflow-hidden`}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/10"></div>
        <div className="relative z-10 flex items-center space-x-4">
          <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
            {facility.icon}
          </div>
          <h3 className="text-2xl font-bold">{facility.title}</h3>
        </div>
      </div>
      
      <div className="p-6">
        <ImageCarousel images={facility.images} title={facility.title} />
        
        <div className="mt-6">
          <p className={`text-gray-700 leading-relaxed transition-all duration-300 ${
            isExpanded ? '' : 'line-clamp-3'
          }`}>
            {facility.description}
          </p>
          
          {facility.description.length > 150 && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="mt-3 text-blue-600 hover:text-blue-800 font-semibold transition-colors duration-200"
            >
              {isExpanded ? 'Read Less' : 'Read More'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const SchoolFacilities: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-white to-blue-100 bg-clip-text text-transparent">
            Ever Green School Facilities
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Discover our world-class facilities designed to provide the best learning environment for our students
          </p>
        </div>
      </div>

      {/* Facilities Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {facilities.map((facility, index) => (
            <FacilityCard key={facility.id} facility={facility} index={index} />
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Excellence in Education</h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Our comprehensive facilities ensure that every student receives the best possible education in a modern, well-equipped environment.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SchoolFacilities;